import { createContext, useEffect, useState, useMemo, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Agreement from '../../components/KYCform/steps/agreement'
import { useGlobalContext } from '../globalContext';
import useStepThreeValues from './stepThreeValues';

export const KYCformStepsContext = createContext(null);
export function KYCformStepsContextProvider({ children }) {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const {
    globalData: { status },
  } = useGlobalContext();
  const { stepThreeValues, setStepThreeValues } = useStepThreeValues();


  const [redirectUrl, setRedirectUrl] = useState(null);

  const [activeStep, setActiveStep] = useState({
    id: 1,
    component: <Agreement />,
    route: `/KYCform/agreement/${i18n.language}`,
  });


  const steps = useMemo(
    () => [
      {
        id: 1,
        title: t('confirmationStep1'),
        disabled: true,
        route: `/KYCform/agreement/${i18n.language}`,
      },
      {
        id: 2,
        title: t('identificationStep2'),
        disabled: status !== 'approved',
        route: `/KYCform/Identomat/${i18n.language}`,
      },
      {
        id: 3,
        title: t('identityInformationUpdate3'),
        disabled: status !== 'approved',
        route: `/KYCform/step/3`,
      },
      {
        id: 4,
        title: t('identityInformation6'),
        disabled: status !== 'approved',
        route: `/KYCform/step/4`,
      },
    ],
    [status, i18n.language, t]
  );



  const nextStep = () => {
    steps.forEach((step) => {
      if (step.id === activeStep.id + 1) {
        history.push(step.route);
      }
    });
  };

  const prevStep = () => {
    if (activeStep.id - 1 !== 2) {
      steps.forEach((step) => {
        if (step.id === activeStep.id - 1) {
          history.push(step.route);
        }
      });
    }
  };

  return (
    <KYCformStepsContext.Provider
      value={{
        activeStep,
        nextStep,
        prevStep,
        redirectUrl,
        setRedirectUrl,
        steps,
        setActiveStep,
        stepThreeValues,
        setStepThreeValues,
      }}
    >
      {children}
    </KYCformStepsContext.Provider>
  );
}

export function useKYCformStepsContext() {
  const value = useContext(KYCformStepsContext);
  if (!value) {
    throw new Error('KYCform Steps context Provider is not defined');
  }
  return value;
}